import React from 'react';
interface EbookMockupProps {
  title: string;
  subtitle?: string;
  variant?: 'primary' | 'secondary' | 'accent';
  className?: string;
}
export function EbookMockup({
  title,
  subtitle,
  variant = 'primary',
  className = ''
}: EbookMockupProps) {
  const bgColors = {
    primary: 'bg-gradient-to-br from-wellness-primary to-wellness-light',
    secondary: 'bg-gradient-to-br from-wellness-gold to-yellow-600',
    accent: 'bg-gradient-to-br from-teal-600 to-wellness-primary'
  };
  return <div className={`book-container w-48 md:w-64 mx-auto ${className}`} data-id="element-23">
      <div className="book relative w-full aspect-[2/3] shadow-2xl rounded-r-lg rounded-l-sm" data-id="element-24">
        {/* Front Cover */}
        <div className={`absolute inset-0 ${bgColors[variant]} rounded-r-lg rounded-l-sm p-6 flex flex-col justify-between border-l-4 border-white/20 z-10 overflow-hidden`} data-id="element-25">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-26"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-black/10 rounded-full -ml-12 -mb-12 blur-xl" data-id="element-27"></div>

          <div className="relative z-10" data-id="element-28">
            <div className="w-8 h-1 bg-wellness-gold mb-4" data-id="element-29"></div>
            <h3 className="text-white font-heading font-bold text-xl md:text-2xl leading-tight mb-2 shadow-sm" data-id="element-30">
              {title}
            </h3>
            {subtitle && <p className="text-white/90 text-sm md:text-base font-body font-medium" data-id="element-31">
                {subtitle}
              </p>}
          </div>

          <div className="relative z-10 flex items-center space-x-2" data-id="element-32">
            <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center" data-id="element-33">
              <span className="text-white text-[10px] font-bold" data-id="element-34">100%</span>
            </div>
            <span className="text-white/80 text-xs uppercase tracking-wider font-semibold" data-id="element-35">
              Natural
            </span>
          </div>
        </div>

        {/* Spine */}
        <div className={`book-spine absolute top-0 left-0 w-8 h-full ${bgColors[variant]} brightness-75 border-r border-black/10 flex items-center justify-center`} data-id="element-36">
          <span className="text-white/50 text-xs font-bold tracking-widest -rotate-90 whitespace-nowrap" data-id="element-37">
            PROGRAMA NATURAL
          </span>
        </div>

        {/* Pages Edge */}
        <div className="absolute top-1 bottom-1 right-0 w-full bg-white -z-10 translate-x-2 rounded-r-md shadow-inner border-y border-r border-gray-200" data-id="element-38"></div>
      </div>
    </div>;
}